/**
 * @generated SignedSource<<8e34ca9ed3df8d3413ee46375c5960f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarTeamEventEditScreenQuery$variables = {
  eventId: string;
  teamId: string;
};
export type CalendarTeamEventEditScreenQuery$data = {
  readonly store: {
    readonly calendarEvent: {
      readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventEditScreenComponent_event">;
    } | null;
    readonly team: {
      readonly calendars: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventEditScreenComponent_storeCalendars">;
      }>;
    } | null;
    readonly timezone: string;
  };
};
export type CalendarTeamEventEditScreenQuery = {
  response: CalendarTeamEventEditScreenQuery$data;
  variables: CalendarTeamEventEditScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "eventId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v5 = [
  {
    "kind": "Literal",
    "name": "includeExternal",
    "value": true
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoString",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarTeamEventEditScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "CalendarEvent",
            "kind": "LinkedField",
            "name": "calendarEvent",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CalendarTeamEventEditScreenComponent_event"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "StoreCalendar",
                "kind": "LinkedField",
                "name": "calendars",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CalendarTeamEventEditScreenComponent_storeCalendars"
                  }
                ],
                "storageKey": "calendars(includeExternal:true)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CalendarTeamEventEditScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "CalendarEvent",
            "kind": "LinkedField",
            "name": "calendarEvent",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "startAt",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "endAt",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAllDayEvent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreCalendar",
                "kind": "LinkedField",
                "name": "storeCalendar",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "StoreCalendar",
                "kind": "LinkedField",
                "name": "calendars",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": "calendars(includeExternal:true)"
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ec8ac44f9acae2364cd778aeb0df559b",
    "id": null,
    "metadata": {},
    "name": "CalendarTeamEventEditScreenQuery",
    "operationKind": "query",
    "text": "query CalendarTeamEventEditScreenQuery(\n  $teamId: ID!\n  $eventId: ID!\n) {\n  store {\n    timezone\n    calendarEvent(id: $eventId) {\n      ...CalendarTeamEventEditScreenComponent_event\n      id\n    }\n    team(id: $teamId) {\n      calendars(includeExternal: true) {\n        ...CalendarTeamEventEditScreenComponent_storeCalendars\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars on StoreCalendar {\n  id\n  title\n  color\n  isExternal\n}\n\nfragment CalendarTeamEventEditComponent_storeCalendars on StoreCalendar {\n  id\n  title\n  color\n  ...CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars\n}\n\nfragment CalendarTeamEventEditScreenComponent_event on CalendarEvent {\n  id\n  title\n  startAt {\n    isoString\n  }\n  endAt {\n    isoString\n  }\n  isAllDayEvent\n  storeCalendar {\n    id\n    isExternal\n  }\n}\n\nfragment CalendarTeamEventEditScreenComponent_storeCalendars on StoreCalendar {\n  ...CalendarTeamEventEditComponent_storeCalendars\n}\n"
  }
};
})();

(node as any).hash = "d1ded7f368f007ecc1be6d5417842b91";

export default node;
